export default __webpack_public_path__ + "static/media/voucherGTS2.8bc01d55.jpg";